import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { DirectionalHint } from '@fluentui/react';
import { ContextualMenuIconButton } from '@bingads-webui-campaign-react/contextual-menu-icon-button';
import { EntityItem } from '@bingads-webui-campaign-react/entity-item';
import { EditableItem, OverflowEntityItem } from './index';
import { getOverflowSubMenuProps } from './overflow-sub-menu';

export class SummaryBarItems extends React.PureComponent {
  renderSummryBarItem = (item, ItemComponent) => {
    const {
      Editor,
      getEditorProps,
      onClick: onItemClick,
      ...other
    } = item;

    if (Editor) {
      const renderEditor = (isOpen, closeEditor, passThroughData) => {
        const editorProps = getEditorProps(isOpen, closeEditor, passThroughData);
        const { getChildren, ...rest } = editorProps;
        return (
          <Editor {...rest}>
            {getChildren && getChildren()}
          </Editor>
        );
      };

      const renderEditableItem = (showEditor) => {
        const onClick = (event) => {
          if (event) {
            event.preventDefault();
          }
          showEditor({ itemProps: other });
          if (onItemClick) {
            onItemClick();
          }
        };

        return (
          <ItemComponent {...other} onClick={onClick} />
        );
      };

      return (<EditableItem renderEditor={renderEditor} renderEditableItem={renderEditableItem} />);
    }

    return (<ItemComponent {...item} />);
  }

  renderOverflowDropdown = (overflowItems) => {
    if (!overflowItems || overflowItems.length === 0) {
      return null;
    }

    const {
      overflowAriaLabel,
    } = this.props;
    const overflowDropdownProps = {
      items: overflowItems.reduce((memo, item) => memo.concat({
        itemProps: { siteMap: this.props.siteMap, ...item },
        disabled: !item.canEdit,
        ...getOverflowSubMenuProps(item),
      }), []),
      iconName: 'More',
      'aria-label': overflowAriaLabel,
      contextualMenuProps: {
        doNotLayer: true,
        DirectionalHint: DirectionalHint.bottomRightEdge,
        contextualMenuItemAs: OverflowEntityItem,
        onDismiss: (event) => {
          const target = event && event.target;

          if (target) {
            const isInsideDatePicker = target && _.isFunction(target.closest) && target.closest('.k-calendar');

            if (isInsideDatePicker) {
              event.preventDefault();
            }
          }
        },
      },
    };

    return (
      <div className="overflow-summary-bar-items">
        <ContextualMenuIconButton {...overflowDropdownProps} />
      </div>
    );
  }

  render() {
    const {
      summaryBarItems,
      overflowIndex,
    } = this.props;
    const overflowItems = _.reject(summaryBarItems.slice(overflowIndex), item => item.noOverflow);
    const isEditable = item => item.canEdit;
    let entityItems = [];

    if (summaryBarItems.length > 0) {
      entityItems = summaryBarItems.map((item) => {
        if (_.contains(overflowItems, item)) {
          return null;
        }

        return (
          <div className={classNames(item.className, isEditable(item) && 'editable')} key={item.className} >
            {item.className === 'overflow-entity-items'
              ? this.renderOverflowDropdown(overflowItems)
              : this.renderSummryBarItem(item, EntityItem)
            }
          </div>
        );
      });
    }

    const overflowLabel = overflowItems.length === 0 ? 'none' : overflowIndex;
    return (
      <div className={classNames('summary-bar-items', `summary-bar-items-overflow-${overflowLabel}`)}>
        {entityItems}
      </div>
    );
  }
}

export const SummaryBarItemPropType = PropTypes.shape({
  label: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  canEdit: PropTypes.bool,
  renderContent: PropTypes.func,
  onClick: PropTypes.func,
  renderEntityItem: PropTypes.func,
});

SummaryBarItems.propTypes = {
  overflowAriaLabel: PropTypes.string,
  summaryBarItems: PropTypes.arrayOf(SummaryBarItemPropType.isRequired).isRequired,
  overflowIndex: PropTypes.number.isRequired,
  siteMap: siteMapPropType.isRequired,
};

SummaryBarItems.defaultProps = {
  overflowAriaLabel: '',
};
